import { performCmdbPostRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { getCmdbUserHistoryViewedUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/user-history-rest.tsx';
import type { WorkspaceId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';

export type EntityType = 'object' | 'object-type' | 'object-schema';

export const trackView = async ({
	workspaceId,
	entityId,
	entityType,
}: {
	workspaceId: WorkspaceId;
	entityId: string;
	entityType: EntityType;
}): Promise<void> => {
	await performCmdbPostRequest(getCmdbUserHistoryViewedUrl(workspaceId), {
		body: JSON.stringify({ entityId, entityType }),
	});
};
